import "./NotFound.css";
import { useTranslation } from 'react-i18next';

function NotFound() {
    const { t } = useTranslation();
    
    return (
        <div className="notFoundPage">
            <div>{t('notFound.message')}</div>
            <button>{t('notFound.backButton')}</button>
        </div>
    )
}

export default NotFound;